var UPDATE_PRODUCT_FIELD = function(key, value) {
  this.SET_PRODUCT_FIELD(this.getKeyValuePair(key, value));
};

var UPDATE_PRODUCT_REGISTRATION_FIELD = function(key, value) {
  this.SET_PRODUCT_REGISTRATION_FIELD(this.getKeyValuePair(key, value));
};


export default {
    methods: {
      UPDATE_PRODUCT_FIELD,
      UPDATE_PRODUCT_REGISTRATION_FIELD
    }
  };

